import { useQuery } from '@tanstack/react-query';
import { loadActiveShipments, loadShipmentHistory, searchContainer } from '../api';
import { keepActivePlaceholder } from '../keepActivePlaceholder';

const ACTIVE_REFETCH_MS = 10 * 60 * 1000;

/**
 * Active sea cards. Party filters re-fetch server-side (render-only FE).
 * Query key includes email so ACL-personalized party fields don't leak across accounts.
 * placeholderData keeps prior options/top3 painted while a filter refetch is in flight
 * for the same account only.
 */
export const useActiveShipments = ({
  importer = '',
  exporter = '',
  email = '',
} = {}) => useQuery({
  queryKey: ['sea-tracking', 'active', email || '', importer || '', exporter || ''],
  queryFn: () => loadActiveShipments({ importer, exporter }),
  staleTime: 5 * 60 * 1000,
  refetchInterval: ACTIVE_REFETCH_MS,
  placeholderData: (prev, prevQuery) => keepActivePlaceholder(prev, prevQuery, email),
});

export const useShipmentHistory = (containerNumber) => useQuery({
  queryKey: ['sea-tracking', 'history', containerNumber],
  queryFn: () => loadShipmentHistory(containerNumber),
  enabled: !!containerNumber,
});

export const useContainerSearch = (query) => useQuery({
  queryKey: ['sea-tracking', 'container-search', query],
  queryFn: () => searchContainer(query),
  enabled: typeof query === 'string' && query.trim().length >= 4,
  staleTime: 2 * 60 * 1000,
});
